export class Video {
  constructor(difference) {
    this.styleId = 1
    this.width = 400
    this.height = 225
    this.top = 10
    this.left = 10
    this.videoUrl = ""
    this.innerElement = "cxVideo"
    this.bgColor = "rgba(255, 255, 255, 0.7)"
    this.rotate = 0
    this.iconBorderStyle = "solid" // solid dashed dotted
    this.iconBorderColor = "rgba(255,255,255,0)"
    this.iconBorderWidth = 0
    this.borderStyle = "solid" // solid dashed dotted
    this.borderColor = "#000000"
    this.borderWidth = 0
    this.opacity = 100
    this.boxShadowColor = []
    this.boxShadowH = []
    this.boxShadowV = []
    this.boxShadowBlur = []
    this.boxShadowSpread = []
    this.borderTypeFlag = 2
    this.borderRadius = 0
    this.borderTopLeftRadius = 0
    this.borderTopRightRadius = 0
    this.borderBottomLeftRadius = 0
    this.borderBottomRightRadius = 0
    this.borderIsThemeColor = false
    // 弹框播放原位播放
    this.dialogPlay = true
    // 循环播放
    this.loopPlay = false
    // 显示控制条
    this.controlStatus = false
    // 自动播放
    this.autoplayStatus = false
    // 图标颜色
    this.iconColor = "rgba(0, 0, 0, 1)"
    this.iconWidth = 40
    this.iconHeight = 40
    this.imgSrc = ""
    // 上传视频的封面
    this.uploadVideoImg = ""
    // 静音只跟自动播放有关系
    this.muted = false
    // 边距
    this.videolegendPadding = 0
    this.videoPaddingTop = 0
    this.videoPaddingRight = 0
    this.videoPaddingLeft = 0
    this.videoPaddingBottom = 0
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
